import * as React from "react";
import { SelectEditorFactory } from "../../../../react-core/Html/Factories/SelectEditorFactory";
import { CommonHelper, Dictionary } from "../../../../react-core/Helpers/CommonHelper";
import { TransferInstructionQuery } from "../Resources/TransferInstructionQuery";
import {
    ReasonMap,
    WizardLabel,
    ReasonReverseMap,
    ReducedReasonMap,
    ReducedReasonReverseMap,
    errorStepOne,
    TransferReason,
} from "../Resources/Content";
import { TextBoxEditor } from "../../../../react-core/Html/TextBoxEditor";
import { InvestmentTable } from "./StepOneComponent/InvestmentTable";
import { IInvestmentTransfer } from "../Stores/InvestmentTransferStoreStatic";
import { DestinationAccount } from "./StepOneComponent/DestinationAccount";
import { PensionDetail } from "./StepOneComponent/PensionDetail";
import { MoveableSubAccountStore } from "../Stores/Variable";
import { getQueryParameters, setQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { TransferDestinationAccountModel } from "../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AlertType } from "../../../Shared/Entities/Constants/AlertConstants";
import { Alert } from "../../../Shared/Components/Alert";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../Shared/Common/UserMessages";
import { RestrictionStore } from "../../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { RestrictionAction } from "../../../Dashboard/Components/Clients/Common/Restrictions/RestrictionAction";
import { Action } from "../../../Dashboard/Actions/Action";
import { User } from "../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../Dashboard/Stroes/Variable";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";
import { TransferSourceAccounts } from "../../../../Wrap/Models/Domains/Transfer/TransferSourceAccounts";

interface ITransferWizardStepOneProps extends React.Props<TransferWizardStepOne> {
    onChange: (key: string, value: any, data?: any) => void;
    data: TransferInstructionQuery;
    investmentData: IInvestmentTransfer[];
    destinationAccount: TransferDestinationAccountModel;
    currentAccount: TransferSourceAccounts;
    isReview: boolean;
    onRef: (ref) => void;
}
interface ITransferWizardStepOneState {
    userInfo: User;
}

export class TransferWizardStepOne extends FormComponent<ITransferWizardStepOneProps, ITransferWizardStepOneState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
        };
    }
    child: any = null;
    investment: any = {};

    componentDidMount() {
        this.props.onRef(this);

        if (RestrictionStore.getData() == null) {
            if (!CommonHelper.isNullOrEmpty(getQueryParameters()["subaccounthierarchyid"])) {
                RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["subaccounthierarchyid"]);
            } else if (!CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])) {
                RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["hierarchyid"]);
            }
        }
    }

    private hasReducedReasonOptions(subAccountType: SubAccountType): boolean {
        return (
            subAccountType === SubAccountType.Npr ||
            subAccountType === SubAccountType.Sipp ||
            subAccountType === SubAccountType.JuniorSipp ||
            subAccountType === SubAccountType.Pension ||
            subAccountType === SubAccountType.AuPension
        );
    }

    private getReasonOptions() {
        const options: Dictionary[] = [];
        const reasonMap = this.hasReducedReasonOptions(MoveableSubAccountStore.getCurrentAccount().SubAccountType)
            ? ReducedReasonMap
            : ReasonMap;

        Object.keys(reasonMap).forEach((reason) => {
            options.push({ key: reason, value: reasonMap[reason] });
        });
        return options;
    }

    render() {
        const { data } = this.props;
        const SourceAccountSelect = SelectEditorFactory.create<string>();
        const ReasonSelect = SelectEditorFactory.create<string>();
        let restrictedMessage = "An account with suspended or restricted activities cannot setup inter transfer";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        const applicableReasonMap = this.hasReducedReasonOptions(
            MoveableSubAccountStore.getCurrentAccount().SubAccountType
        )
            ? ReducedReasonMap
            : ReasonMap;
        const applicableReasonReverseMap = this.hasReducedReasonOptions(
            MoveableSubAccountStore.getCurrentAccount().SubAccountType
        )
            ? ReducedReasonReverseMap
            : ReasonReverseMap;

        return (
            <>
                {RestrictionStore.InterAccountTransferDisabled() && (
                    <Alert alertType={AlertType.Error} message={restrictedMessage} />
                )}

                <div className="form-group">
                    <SourceAccountSelect
                        cssWrapper="control-size-430"
                        key="SourceAccount"
                        label="Selected source"
                        selected={getQueryParameters()["hierarchyid"]}
                        options={MoveableSubAccountStore.getOptions()}
                        getText={(x) => CommonHelper.getOptionsTxt(x, MoveableSubAccountStore.getOptionsMap())}
                        onChange={(val) => {
                            const params = getQueryParameters();
                            params["hierarchyid"] = val;
                            window.location.assign(`${window.location.pathname}${setQueryParameters(params)}`);
                        }}
                        disabled={this.props.isReview}
                    />
                </div>

                <InvestmentTable
                    onChange={this.props.onChange}
                    data={this.props.investmentData}
                    isReview={this.props.isReview}
                    onRef={(ref) => (this.investment = ref)}
                    destinationAccount={this.props.destinationAccount}
                />
                <DestinationAccount
                    onChange={this.props.onChange}
                    data={this.props.destinationAccount}
                    isReview={this.props.isReview}
                    serviceProposition={
                        this.props.currentAccount
                            ? this.props.currentAccount.ServiceProposition
                            : ServiceProposition.NotSpecified
                    }
                />
                <div className="module">
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <ReasonSelect
                                validationRules={[
                                    {
                                        errorMessage: errorStepOne.reason,
                                        validator: (v) => {
                                            return v === TransferReason.NotSpecified.toString() ? false : true;
                                        },
                                    },
                                ]}
                                key="Reason"
                                label={WizardLabel.reason}
                                selected={data.Reason.toString()}
                                options={Object.keys(applicableReasonMap)}
                                getText={(x) => CommonHelper.getOptionsTxt(x, this.getReasonOptions())}
                                onChange={(val) => {
                                    this.props.onChange("Reason", applicableReasonReverseMap[val]);
                                }}
                                disabled={this.props.isReview}
                            />
                        </div>
                        {data.Reason === TransferReason.Other && (
                            <div className="col-12 col-sm-6">
                                <TextBoxEditor
                                    validationRules={[
                                        {
                                            errorMessage: errorStepOne.detail,
                                            validator: (v) => {
                                                return v.length < 1 ? false : true;
                                            },
                                        },
                                    ]}
                                    value={data.Detail}
                                    label={WizardLabel.detail}
                                    onChange={(v) => {
                                        this.props.onChange("Detail", v);
                                    }}
                                    disabled={this.props.isReview}
                                />
                            </div>
                        )}
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <TextBoxEditor
                                validationRules={[
                                    {
                                        errorMessage: errorStepOne.reference,
                                        validator: (v) => {
                                            return v.length < 1 ? false : true;
                                        },
                                    },
                                ]}
                                value={data.Reference}
                                label={WizardLabel.reference}
                                onChange={(v) => {
                                    this.props.onChange("Reference", v);
                                }}
                                disabled={this.props.isReview}
                            />
                        </div>
                    </div>
                </div>
                {MoveableSubAccountStore.getCurrentAccount().SubAccountType == SubAccountType.Pension && (
                    <div style={{ margin: "20px auto", padding: "30px", border: "1px solid #c1c1c1" }}>
                        <PensionDetail
                            data={data.PensionTransferDetail}
                            onChange={this.props.onChange}
                            onRef={(ref) => (this.child = ref)}
                        />
                    </div>
                )}
            </>
        );
    }
}
